import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function E({ callBuy }: any) {
    const { useLang, useState, useEffect, useRouter, Link } = useGlobal();
    const { t } = useLang('powerindependence');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);

    const cards: any = [
        {
            img: `/responsive/picture/power-independence/4_1`,
            power: t('secE_card1_power'),
            title: t('secE_card1_title'),
            desc: t('secE_card1_desc'),
            lists: [
                {
                    title: t('secE_card1_list1_title'),
                    desc: t('secE_card1_list1_desc'),
                },
                {
                    title: t('secE_card1_list2_title'),
                    desc: t('secE_card1_list2_desc'),
                },
                {
                    title: t('secE_card1_list3_title'),
                    desc: t('secE_card1_list3_desc'),
                },
                {
                    title: t('secE_card1_list4_title'),
                    desc: t('secE_card1_list4_desc'),
                },
            ],
            link_more: `https://enterprise.ecoflow.com/${locale === 'fr' ? 'eu' : locale}/products/PowerOcean-DC-Fit`,
        },
        {
            img: `/responsive/picture/power-independence/4_2`,
            power: t('secE_card2_power'),
            title: t('secE_card2_title'),
            desc: t('secE_card2_desc'),
            lists: [
                {
                    title: t('secE_card2_list1_title'),
                    desc: t('secE_card2_list1_desc'),
                },
                {
                    title: t('secE_card2_list2_title'),
                    desc: t('secE_card2_list2_desc'),
                },
                {
                    title: t('secE_card2_list3_title'),
                    desc: t('secE_card2_list3_desc'),
                },
                {
                    title: t('secE_card2_list4_title'),
                    desc: t('secE_card2_list4_desc'),
                },
                {
                    title: t('secE_card2_list5_title'),
                    desc: t('secE_card2_list5_desc'),
                },
            ],
            link_more: `https://www.ecoflow.com/${locale === 'fr' ? 'eu' : locale}/home-battery/PowerOcean`,
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="power-independence-E" className={`power-independence-E ${css['power-independence-E']}`}>
            <div className="ef-box">
                <Swiper className="cards swiper-box" effect="fade" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                    {cards?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <EFPicture src={`${card?.img}.jpg`} alt={card?.title} />
                            <div className="card-info">
                                <p className="card-power">{card?.power}</p>
                                <p className="card-title">{card?.title}</p>
                                <p className="card-desc">{card?.desc}</p>
                                <ul className="card-lists">
                                    {card?.lists?.map((list: any) => (
                                        <li className="card-list" key={list?.title}>
                                            <p className="list-title">{list?.title}</p>
                                            <p className="list-desc">{list?.desc}</p>
                                        </li>
                                    ))}
                                </ul>
                                <div className="card-btns">
                                    {card?.link_more && (
                                        <Link
                                            className="btn-more card-btn"
                                            href={`${card?.link_more}${
                                                String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                            }utm_source=scenario+page&utm_medium=Pillar`}
                                            target="_blank"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'select_product',
                                                list_name: t('secE_title'),
                                                product_name: card.title,
                                                button_name: t('common_card_more'),
                                            }}
                                        >
                                            {t('common_card_more')}
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
